module.exports = __webpack_public_path__ + "img/endereco.f440a027.svg";